import { Box, styled, SxProps, useTheme } from "@mui/material";
import { themeSettings } from "../../../../configuration/themeSettings";

export const BoxNoteTextContainerStyled = styled(Box, {
    label: "OrderOffer-BoxNoteTextContainerStyled",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
}));

export const BoxNoteOperationStyled = styled(Box, {
    label: "OrderOffer-BoxNoteOperationStyled",
})(({ theme }) => ({
    display: "flex",
    justifyContent: 'flex-end',
    padding: 5,
    paddingTop:0,
}));

export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        iconOperation: {
            fontSize: "12px",
            fontWeight: "bold",
        } as SxProps,
        multiline: {
            padding: '10px 10px 3px',
            

            " .MuiDialogContent-root": {
                padding: "1px",
            },
            " .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.grey,
                borderWidth: "1px",
            },

            " .MuiInputBase-multiline ": {
                margin: "0px", // Adjust the margin of the text inside the multiline TextField
                padding: "5px",
                color: themeSettings.main.palette.primary.main,
                fontFamily: themeSettings.main.typography.fontFamily,
                fontSize: "12px",
                width: "300px",
            },
        } as SxProps,

        inputMultiline: {
            color: theme.palette.grey,
            " .MuiDialogContent-root": {
                padding: "1px",
            },
        } as SxProps,
    };
    return classes;
};


